export default "__VITE_ASSET__CSjHZE7T__"